type EarlyErrorRecord = {
  type: 'error' | 'unhandledrejection';
  message: string;
  error?: unknown;
  time: number;
};

declare global {
  interface Window {
    __EARLY_ERRORS__?: EarlyErrorRecord[];
  }
}

export function setupEarlyErrorBuffer(): void {
  if (!window.__EARLY_ERRORS__) window.__EARLY_ERRORS__ = [];

  const push = (rec: EarlyErrorRecord) => {
    try {
      window.__EARLY_ERRORS__!.push(rec);
    } catch {
      /* noop */
    }
  };

  // Only attach once
  const marker = '__EARLY_ERRORS_LISTENERS_ATTACHED__';
  if ((window as any)[marker]) return;
  (window as any)[marker] = true;

  window.addEventListener('error', (e) => {
    push({
      type: 'error',
      message: e.message || 'Unknown error',
      error: e.error || e.filename,
      time: Date.now(),
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason = (e as PromiseRejectionEvent).reason;
    push({
      type: 'unhandledrejection',
      message: (reason && (reason.message || String(reason))) || 'Unhandled rejection',
      error: reason,
      time: Date.now(),
    });
  });
}

export function getAndClearEarlyErrors(): EarlyErrorRecord[] {
  const list = window.__EARLY_ERRORS__ || [];
  window.__EARLY_ERRORS__ = [];
  return list;
}


